import { render, staticRenderFns } from "./CardJurados.vue?vue&type=template&id=5953f8ba&scoped=true"
import script from "./CardJurados.vue?vue&type=script&lang=js"
export * from "./CardJurados.vue?vue&type=script&lang=js"
import style0 from "./CardJurados.vue?vue&type=style&index=0&id=5953f8ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5953f8ba",
  null
  
)

export default component.exports